const videoSrcDesktop = 'https://cdn.naos.ru/media/landing/bioderma_photoderm_xdefense/video21.mp4';
const videoSrcMobile = 'https://cdn.naos.ru/media/landing/bioderma_photoderm_xdefense/video21.mp4';

$.widget('photoderm.video', {
	_create() {
		this._cache();
		this._prime();
		this._bind();
	},

	_bind() {
		this.$playBtn.on('click', () => this._play());
	},

	_cache() {
		this.$element = $(this.element);
		this.$wrapper = this.$element.closest('.photoderm-video');
		this.$playBtn = this.$wrapper.find('[data-role=video-play]');
	},

	_prime() {
		const src = $(window).width() < 768 ? videoSrcMobile : videoSrcDesktop;
		this.$element.find('source').attr('src', src);
		this.$element[0].load();
	},

	_play() {
		if (this.playingStarted) {
			return;
		}
		this.playingStarted = true;

		const videoSrc = $(window).width() < 768 ? videoSrcMobile : videoSrcDesktop;
		this.$element.find('source').attr('src', videoSrc);
		const el = this.$element[0];
		el.load();
		el.play().then(() => {
			el.controls = true;
			this.$playBtn.addClass('_hidden');
		}).catch(() => {});
	}
});
